<template>
  <div class="container-fluid p-0 h-100">
    <h3><strong>Ops</strong> Links</h3>
    <ops-links-grid></ops-links-grid>
  </div>
</template>

<script>
import OpsLinksGrid from "@/components/grids/ops-links-grid.vue";
export default {
  components: {
    "ops-links-grid": OpsLinksGrid
  },
  data: function() {
    return {
      columns: [
        {
          sortable: true,
          filter: true,
          field: "linkName",
          headerName: "Link Name",
          editable: false
        },
        {
          sortable: true,
          filter: true,
          field: "id",
          headerName: "ID",
          editable: false
        },
        {
          sortable: true,
          filter: true,
          field: "username",
          headerName: "Username",
          type: "String",
          editable: false
        },
        {
          sortable: true,
          filter: true,
          field: "password",
          headerName: "Password",
          editable: false
        },
        {
          sortable: true,
          filter: true,
          field: "link",
          headerName: "Link",
          editable: false
        }
      ]
    };
  }
};
</script>

<style></style>
